import * as React from 'react'
import { Locale, NewConversationWidgetCard, Widget, WidgetCardBaseProps } from "../../../../types"
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import ERoute from '../../../ERoute'
import Card from '../Card'
import { useTranslation } from 'react-i18next'
import Icon from '../../../../components/Icons/Icon'
import { useSelector } from 'react-redux'
import { AppState } from '../../../store'
import MobilityHelper from '../../../../helpers/MobilityHelper'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  svg {
    width: 16px;
    height: 16px;
  }
`

const Title = styled.div`
  margin-right: auto;
  flex: 1 1 0%;
  font-size: 14px;
  line-height: 21px;
  min-width: 0px;
  font-weight: 500;
  padding-right: 20px;
  overflow: auto;
  text-overflow: ellipsis;
  white-space: nowrap;
`

type IProps = WidgetCardBaseProps & {
  card: NewConversationWidgetCard
}

const NewConversation = (props: IProps) => {
  const { widget, locale } = props
  const { t } = useTranslation()
  const history = useHistory()

  const onStartConversationClick = () => {
    history.push(ERoute.PATH_CONVERSATION)
  }

  return (
    <Card onClick={onStartConversationClick}>
      <Container>
        <Title>{MobilityHelper.getTranslation(locale, widget.translations, 'start_conversation_button_text')}</Title>
        <Icon icon='messenger-send' />
      </Container>
    </Card>
  )
}

export default NewConversation